// Dates are shown in Ulaanbaatar time on the server and in the browser alike,
// so server-rendered and hydrated text match.
const TIME_ZONE = 'Asia/Ulaanbaatar';
const WEEKDAYS = ['Ням', 'Даваа', 'Мягмар', 'Лхагва', 'Пүрэв', 'Баасан', 'Бямба'];

function parts(iso: string) {
  const values = Object.fromEntries(
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
      weekday: 'short',
    })
      .formatToParts(new Date(iso))
      .map((p) => [p.type, p.value]),
  );
  const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(values.weekday);
  return {
    year: values.year,
    month: Number(values.month),
    day: Number(values.day),
    time: `${values.hour}:${values.minute}`,
    weekday: WEEKDAYS[weekday] ?? '',
  };
}

// "10 сарын 10"
export function formatDay(iso: string): string {
  const p = parts(iso);
  return `${p.month} сарын ${p.day}`;
}

// "10 сарын 10–11" / "10 сарын 31 – 11 сарын 2"
export function formatDateRange(start: string | null, end: string | null): string {
  if (!start) return '';
  const a = parts(start);
  if (!end) return `${a.year} оны ${a.month} сарын ${a.day}`;
  const b = parts(end);
  if (a.month === b.month && a.day === b.day) return `${a.year} оны ${a.month} сарын ${a.day}`;
  if (a.month === b.month) return `${a.year} оны ${a.month} сарын ${a.day}–${b.day}`;
  return `${a.year} оны ${a.month} сарын ${a.day} – ${b.month} сарын ${b.day}`;
}

// "10 сарын 10, Бямба"
export function formatDayWithWeekday(iso: string): string {
  const p = parts(iso);
  return `${p.month} сарын ${p.day}, ${p.weekday}`;
}

export function formatTime(iso: string): string {
  return parts(iso).time;
}
